import { createContext, useEffect, useReducer } from "react";

import axios from "../utils/axios";
import OttPlanReducer from "../reducers/OttPlanReducer";
import { OttPlanConstants } from "../constants/index";
import { saveFile } from "../utils/common";

const initialState = {
  ottPlan: {},
  paging: {
    hasNextPage: false,
    hasPreviousPage: false,
    pageNumber: 0,
    pageSize: 0,
    totalNumberOfPages: 0,
    totalNumberOfRecords: 0,
  },
  ottPlans: [],
  isLoadingOttPlans: true,
  ottPlanAutoSearchResults: {
    data: [],
    paging: {
      hasNextPage: false,
      hasPreviousPage: false,
      pageNumber: 0,
      pageSize: 0,
      totalNumberOfPages: 0,
      totalNumberOfRecords: 0,
    },
  },
  autoSearchLoading: false,
};

const OttPlanContext = createContext({
  ...initialState,
  getOttPlan: () => {},
  getAllOttPlans: () => {},
  downloadFile: () => {},
  autoSearchOttPlans: () => {},
});

function OttPlanProvider({ children }) {
  const [state, dispatch] = useReducer(OttPlanReducer, initialState);

  const getAllOttPlans = async (payload) => {
    try {
      dispatch({
        type: OttPlanConstants.FETCH_OTT_PLAN_REQUEST,
      });
      const response = await axios.post("/ott-plan/list", payload);
      dispatch({
        type: OttPlanConstants.FETCH_OTT_PLAN_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (exception) {
      dispatch({
        type: OttPlanConstants.FETCH_OTT_PLAN_FAILURE,
      });
    }
  };

  const downloadFile = async (fileType, payload) => {
    dispatch({
      type: OttPlanConstants.DOWNLOAD_OTT_REQUEST,
      payload: {
        fileType: fileType,
      },
    });
    const response = await axios.post("/ott-plan/export/" + fileType, payload, {
      responseType: "blob",
    });
    console.log(response.headers, "filename");
    //const filename = response.headers.get("content-disposition").split('"');

    await saveFile(response.data, "ott." + fileType);
    dispatch({
      type: OttPlanConstants.DOWNLOAD_OTT_SUCCESS,
      payload: response.data,
    });
  };
  const autoSearchOttPlans = async (payload) => {
    try {
      const response = await axios.post("/ott-plan/auto-search", payload);
      dispatch({
        type: OttPlanConstants.OTT_PLAN_AUTO_SEARCH_REQUEST,
      });

      dispatch({
        type: OttPlanConstants.OTT_PLAN_AUTO_SEARCH_SUCCESS,
        payload: response.data,
      });
    } catch (exception) {
      dispatch({
        type: OttPlanConstants.OTT_PLAN_AUTO_SEARCH_FAILURE,
      });
    }
  };

  const getOttPlan = async (id) => {
    const response = await axios.get("/ott-plan/" + id);
    dispatch({
      type: OttPlanConstants.GET_OTT_PLAN_REQUEST,
    });
    dispatch({
      type: OttPlanConstants.GET_OTT_PLAN_SUCCESS,
      payload: response.data,
    });
  };

  return (
    <OttPlanContext.Provider
      value={{
        ...state,
        getAllOttPlans,
        downloadFile,
        autoSearchOttPlans,
        getOttPlan,
      }}
    >
      {children}
    </OttPlanContext.Provider>
  );
}

export { OttPlanContext, OttPlanProvider };
